// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1827 ? "45aec727" : chunkId) + "." + {"1827":"02b036366ecae3d1","2413":"d8a44920f4392750","3697":"45bb127618aa8996","5791":"3c7b9340c6361095","7289":"fe68b6c8ee39de56","8505":"1f71dc12a56b44a8"}[chunkId] + ".js";
};